"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13 7H9V3c0-.55-.45-1-1-1s-1 .45-1 1v4H3c-.55 0-1 .45-1 1s.45 1 1 1h4v4c0 .55.45 1 1 1s1-.45 1-1V9h4c.55 0 1-.45 1-1s-.45-1-1-1z"];
//# sourceMappingURL=plus.js.map